import React from 'react';
import { PlusIcon } from 'lucide-react';

type NodeEditorHeaderProps = {
    typeLabel: string,
    childNodeLength: number,
    onChildNodeAdd: () => void
};

const NodeEditorHeader = ({ typeLabel, childNodeLength, onChildNodeAdd }: NodeEditorHeaderProps) => {
    return (
        <div className="flex items-center mb-3">
            <span className='mr-5'>Number of {typeLabel}: {childNodeLength} </span>
            <button
                type="button"
                className="text-white bg-primary-blue hover:bg-blue-800 focus:outline-none font-medium rounded-lg text-sm px-2.5 py-1.5 text-center inline-flex items-center me-2"
                onClick={onChildNodeAdd}>
                <PlusIcon className="me-2 text-sm" /> Add
            </button>
        </div>
    )
}

export default NodeEditorHeader;